import {
    AppFormItem,
    AppFormItemProps,
    AppInput,
    FetchNurseryRegistryInformationButton,
} from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { commonTexts } from 'consts/text';
import { nurseryRegisterNumberRegExp } from 'consts/regexps';

export const NurseryRegisterNumberInputWithFetchElement = (props: AppFormItemProps) => (
    <>
        <AppFormItem
            label={commonTexts.dataLabels.nurseryRegistryNumber}
            name={formFields.nurseryRegistryNumber}
            marginBottom={6}
            rules={[
                {
                    pattern: nurseryRegisterNumberRegExp,
                    message: commonTexts.errorMessages.invalidNurseryRegistryNumber,
                },
            ]}
            {...props}
        >
            <AppInput autoComplete="off" placeholder="Podaj numer rejestracji" />
        </AppFormItem>
        <FetchNurseryRegistryInformationButton />
    </>
);
